import React, { Component } from 'react';
import A from 'app/components/A';
import IconButton from 'app/components/IconButton';
import Search from 'app/components/Search';
import styled from 'styled-components';
import { IoIosArrowDropleftCircle, IoIosLogOut } from 'react-icons/io';
import { connect } from 'react-redux';
import { AiOutlineFileSearch } from 'react-icons/ai';
import axiosService from 'app/context/service';
import QRCode from 'qrcode';
import Swal from 'sweetalert2';
import { RiQrCodeLine } from 'react-icons/ri';
import { getUser } from 'utils/permissions';

import eventBus from '../../EventBus';

const HeaderStore = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const HeaderCurrentLocation = styled.div`
    color: #0c1635;
    font-weight: 500;
    font-size: 18px;
    a {
        color: #0c1635;
        font-weight: 500;
        font-size: 18px;
    }
    &.padding-left {
        padding-left: 10px;
    }
`;

const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    margin-left: 20px;
`;

const mapStateToProps = state => ({
    header: state.header,
});

class Header extends Component {
    state = {
        sidebarOpen: true,
    };

    componentDidUpdate() {
        eventBus.on('sidebarState', data => {
            this.setState({ sidebarOpen: data.sidebarOpen });
        });
    }

    goBack() {
        window.history.back();
    }

    lastLink(path) {
        var r = null;
        if (path) {
            path.forEach(elm => {
                if (elm.link !== null) {
                    r = elm.link;
                }
            });
        }
        return r;
    }

    openMobileQr = async () => {
        try {
            const res = await axiosService.post('mobile/qr-token');
            if (res.status === 200) {
                const dataUrl = await QRCode.toDataURL(res.data.deep_link, { width: 256 });
                Swal.fire({
                    title: "Se connecter à l'application mobile",
                    text: "Scannez ce QR avec l'app mobile — valable 5 minutes.",
                    imageUrl: dataUrl,
                    imageWidth: 256,
                    imageHeight: 256,
                    imageAlt: 'QR de connexion',
                });
            }
        } catch (e) {
            Swal.fire('Impossible de générer le QR', '', 'error');
        }
    };

    render() {
        const HeaderStyled = styled.div`
            padding: 10px;
            position: fixed;
            width: ${this.state.sidebarOpen ? 'calc(100% - 200px)' : 'calc(100% - 70px)'};
            top: 0px;
            left: auto;
            height: 70px;
            background-color: #ffffff;
            display: flex;
            align-items: center;
            z-index: 500;
            border-bottom: 2px solid whitesmoke;
            @media (max-width: 1024px) {
                width: calc(100% - 70px);
                left: 70px;
            }
        `;

        var lastPathlink = this.lastLink(this.props['header']['location']['path']);
        return (
            <HeaderStyled>
                {lastPathlink && (
                    <A to={lastPathlink ?? ''}>
                        <IconButton label="" icon={IoIosArrowDropleftCircle({ size: 30, color: '#0c1635' })} bgColor="transparent" color="#ffffff" />
                    </A>
                )}

                <HeaderStore>
                    <HeaderCurrentLocation className={`${!lastPathlink ? 'padding-left' : ''}`}>
                        {this.props['header']['location']['path'] &&
                            this.props['header']['location']['path'].map((e, key) => {
                                return (
                                    <span key={key}>
                                        {!e.link && e.title}
                                        {e.link && <A to={e.link}>{e.title}</A>}
                                        {this.props['header']['location']['path'].length - 1 > key && ' > '}
                                    </span>
                                );
                            })}
                    </HeaderCurrentLocation>
                    {this.props['header']['location']['action'] && <HeaderActions>{this.props['header']['location']['action']}</HeaderActions>}
                </HeaderStore>

                <Search />
                <A to="/search">
                    <IconButton label="" icon={AiOutlineFileSearch({ size: 30, color: '#0c1635' })} bgColor="transparent" color="#ffffff" />
                </A>
                {getUser()?.appAccess && (
                    <IconButton
                        label="Se connecter à l'application mobile"
                        icon={RiQrCodeLine({ size: 22, color: '#ffffff' })}
                        onClick={this.openMobileQr}
                        bgColor="#0c1635"
                        color="#ffffff"
                        marginRight="10px"
                    />
                )}
                <A to="/logout">
                    <IconButton label="" icon={IoIosLogOut({ size: 30, color: '#0c1635' })} bgColor="transparent" color="#ffffff" />
                </A>
            </HeaderStyled>
        );
    }
}

export default connect(mapStateToProps)(Header);
